module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/3@2x_4585896f1e449a59f667dd2a4d3a1e44.png";